/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @next/next/no-img-element */
import classNames from 'classnames';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useContext, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useSelector } from 'react-redux';
import {
  BESTSELLER,
  PLEASE_CHOOSE,
  PLEASE_CHOOSE_ONE_OPTION,
  PLEASE_CHOOSE_ANOTHER_OPTION,
  DEPOSIT_MESSAGE,
  DEPOSIT_PAY_DEPOSIT,
  DEPOSIT_PAY_FULL,
  CUE_VIP_EXCLUSIVE,
  SOLD_OUT,
  BESTSELLER_EXPLAIN,
} from '../../../../config/text/text';
import { isLightPage } from '../../../../helpers/browser';
import {
  getColumn,
  getImageIndexForVariant,
  getRow,
  getSecondCheckoutRow,
} from '../../../../helpers/chooseYourOptions';
import { formatCurrency } from '../../../../helpers/currency';
import { formatNames, isDepositDeal } from '../../../../helpers/deals';
import { updateProductPageDetails } from '../../../../helpers/productPage';
import HeaderContext from '../../../../providers/ProductIdProvider';
import ThemeContext from '../../../../providers/ThemeProvider';
import Message from '../../../_generic/Message';
import RadioButtonWithLabel from '../../../_generic/radio-button/RadioButtonWithLabel';
import DealPriceSplat from '../DealPriceSplat';

export const layoutOptions = {
  travel: 'travel',
};

const ChooseYourOptionsDropdown = ({
  deal = {},
  layout,
  setIsOptionSelected = () => {},
  setImageVariantIndex,
  rowSelection,
  setRowSelection,
  selectedOption,
  setSelectedOption,
  isModernVipVariant = false,
  showEmptyMessage,
  setShowEmptyMessage,
  columnSelection,
  setColumnSelection,
  isMobile,
  isChooseYourProductDeal,
  setProductStatus,
  productId,
  setProductPageId,
  setPdtUrl,
  setFilteredProduct,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const router = useRouter();
  const [isVipUser] = useSelector((state) => [
    state?.user?.userprofile?.vipUser,
  ]);
  const [payDeposit, setPayDeposit] = useState(deal?.depositAvailable || false); // deposit or payment in full
  const theme = useContext(ThemeContext);
  const isProductPage = true;
  const row = isChooseYourProductDeal
    ? getSecondCheckoutRow(deal, isVipUser, isProductPage)
    : getRow(deal, isVipUser, isProductPage);
  const bestsellerRow = row?.items.filter((element) => element.isBestseller);
  const [column, setColumn] = useState(() =>
    getColumn(deal, rowSelection, isVipUser, isProductPage),
  );
  const bestsellerProduct = column?.items.find(
    (element) => element.isBestseller,
  );
  const [productionId, setProductionId] = useState(productId);
  const isSingleDropDown = isChooseYourProductDeal
    ? true
    : deal?.productDisplay?.column?.items.length <= 1;

  const isLayoutTravel = Boolean(layout === layoutOptions.travel);
  const { setHeaderState } = useContext(HeaderContext);

  useEffect(() => {
    if (rowSelection !== 0) {
      const selection = deal.products.findIndex((item) =>
        isChooseYourProductDeal
          ? item.id === rowSelection
          : item.rowId === rowSelection,
      );
      setProductStatus(deal?.products[selection]?.soldOut);
      setSelectedOption(selection);
    }
    if (rowSelection !== 0 && columnSelection !== 0) {
      const selection = deal.products.findIndex((item) =>
        isChooseYourProductDeal
          ? item.id === rowSelection
          : item.rowId === rowSelection && item.columnId === columnSelection,
      );
      setProductStatus(deal?.products[selection]?.soldOut);
      setSelectedOption(selection);
    }
  }, [rowSelection, columnSelection]);

  const onRowChange = (rowId) => {
    const id = Number.parseInt(rowId, 10);
    const col = getColumn(deal, id, isVipUser, isProductPage);
    setRowSelection(id);
    setColumn(col);
    const colSelection = col.items.length === 1 ? col.items[0].id : 0;

    setColumnSelection(colSelection);

    const selection = deal.products.findIndex((item) =>
      isChooseYourProductDeal
        ? item.id === rowSelection
        : item.rowId === id && item.columnId === colSelection,
    );
    setSelectedOption(selection);

    setShowEmptyMessage(false);
    if (column.items.length === 1) setIsOptionSelected(true);

    const newProduct = deal?.products?.filter((product) =>
      isChooseYourProductDeal ? product.id === rowId : product.rowId === rowId,
    );
    const newProductId = newProduct[0]?.id;
    if (
      newProductId &&
      (column.items.length === 1 || isChooseYourProductDeal)
    ) {
      updateProductIdInUrl(newProductId);
      setProductPageId(newProductId);
      setProductionId(newProductId);
      setImageVariantIndex(
        getImageIndexForVariant(
          deal,
          rowId,
          columnSelection,
          newProductId,
          isChooseYourProductDeal,
        ),
      );
    }
  };

  const onSecondRowChange = (colId) => {
    const secondValue = Number.parseInt(colId, 10);
    setColumnSelection(secondValue);

    if (deal.depositAvailable) {
      setPayDeposit(Boolean(secondValue));
    }
    const selection = deal.products.findIndex(
      (item) => item.rowId === rowSelection && item.columnId === secondValue,
    );
    setSelectedOption(selection);
    setShowEmptyMessage(false);
    setIsOptionSelected(true);
    const newProduct = deal?.products?.filter(
      (item) => item.rowId === rowSelection && item.columnId === secondValue,
    );
    const newProductId = newProduct[0]?.id;
    if (newProductId) {
      updateProductIdInUrl(newProductId);
      setProductPageId(newProductId);
      setProductionId(newProductId);
      setImageVariantIndex(
        getImageIndexForVariant(deal, rowSelection, secondValue),
      );
    }
  };

  const updateProductIdInUrl = (newProductId) => {
    const path = router.asPath;
    let newColName = null;
    let newRowName = null;
    let seotitle = null;

    let newpath = path?.split('/');
    const additionalParameters = path?.split('?')[1] || '';
    newpath[newpath?.length - 1] = deal?.dealPrefix;
    newpath = newpath.join('/');
    // Extracting the second number from the URL
    const regex = /\b(\d+)\/([^/]+)\/([^/]+)$/;
    const match = newpath.match(regex);
    if (!match) {
      console.error('Second number not found in URL');

      return;
    }
    const existingNumber = match?.[2];
    const pdt = deal?.products?.find((pdt) => pdt?.id == newProductId);

    if (!isSingleDropDown) {
      newRowName = deal?.productDisplay?.row?.items?.find(
        (item) => item?.id == pdt?.rowId,
      )?.header;
      newColName = deal?.productDisplay?.column?.items?.find(
        (item) => item?.id == pdt?.columnId,
      )?.header;
      newRowName = formatNames(newRowName);
      newColName = formatNames(newColName);
      newpath =
        newpath.replace(existingNumber, newProductId) +
        `-${newRowName}-${newColName}`;
    } else {
      seotitle = match?.[3];
      newRowName = isChooseYourProductDeal
        ? pdt?.friendlyName
        : deal?.productDisplay?.row?.items?.find(
            (item) => item?.id == pdt?.rowId,
          )?.header;
      newRowName = formatNames(newRowName);
      newpath =
        newpath.replace(existingNumber, newProductId) +
        `${isChooseYourProductDeal ? '/' : '-'}${newRowName}`;

      if (isChooseYourProductDeal && seotitle !== null)
        newpath = newpath.replace(`/${seotitle}`, '');
    }
    setPdtUrl(`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${newpath}`);
    setHeaderState(`${process.env.NEXT_PUBLIC_BASE_ROOT_URL}${newpath}`);
    setFilteredProduct(pdt);

    if (additionalParameters.length > 0) newpath += `?${additionalParameters}`;

    window?.history?.replaceState(null, null, newpath);
  };

  const getPdtUrlWithTwoDropDown = (products, colId) => {
    const pdt = products?.find(
      (pdt) => pdt.rowId == rowSelection && pdt?.columnId == colId,
    );
    let path = router?.asPath;
    path = path.split('?')[0];
    const spliturl = path?.split('/');
    for (let index = 0; index < spliturl?.length; index++) {
      if (deal?.id == spliturl[index]) {
        spliturl[index + 1] = pdt?.id;
      }
    }
    spliturl[spliturl?.length - 1] = deal?.dealPrefix;
    let rowName = deal?.productDisplay?.row?.items?.find(
      (item) => item.id == rowSelection,
    )?.header;
    let colName = deal?.productDisplay?.column?.items?.find(
      (item) => item.id == colId,
    )?.header;
    rowName = formatNames(rowName);

    colName = formatNames(colName);

    return `${spliturl?.join('/')}-${rowName}-${colName}`;
  };

  const getPdtUrlWithOneDropDown = (products, id) => {
    let assignedLength = -1;
    const pdt = isChooseYourProductDeal
      ? products?.find((pdt) => pdt?.id == id)
      : products?.find((pdt) => pdt.rowId == id);

    let path = router?.asPath;
    path = path.split('?')[0];
    const spliturl = path?.split('/');
    for (let index = 0; index < spliturl?.length; index++) {
      if (deal?.id == spliturl[index]) {
        spliturl[index + 1] = pdt?.id;
        assignedLength = index + 1;
      }
    }
    spliturl[spliturl?.length - 1] = deal?.dealPrefix;
    if (assignedLength !== -1 && isChooseYourProductDeal)
      spliturl.length = assignedLength + 1;

    let rowName = isChooseYourProductDeal
      ? pdt?.friendlyName
      : deal?.productDisplay?.row?.items?.find((item) => item.id == id)?.header;
    rowName = formatNames(rowName);

    return `${spliturl?.join('/')}${
      isChooseYourProductDeal ? '/' : '-'
    }${rowName}`;
  };

  const getDropdownDisplayItem = (item) => {
    if (item.disabled) {
      return (
        <span className="disabled-text text-wrap">
          {item.displayAs} - {SOLD_OUT}
        </span>
      );
    } else if (item?.isModernVipVariant && !isVipUser) {
      return (
        <span className={`text-wrap ${item.isBestseller ? 'green-text' : ''}`}>
          <span>{`${item?.modernSplatVariantData?.header} - ${item?.modernSplatVariantData?.newFormatPrefix}`}</span>
          <span className="vip-new-variant">
            {item?.modernSplatVariantData?.vipPrice}
          </span>
          <span>{`${item?.modernSplatVariantData?.normalPrice} ${
            item.isBestseller ? `- ${BESTSELLER}` : ''
          }`}</span>
        </span>
      );
    } else if (item.isBestseller) {
      return (
        <span className="green-text text-wrap">
          {item.displayAs} - {BESTSELLER}
        </span>
      );
    } else {
      return <span className="text-wrap">{item.displayAs}</span>;
    }
  };
  const DepositMessage = () => {
    if (!isDepositDeal(deal)) {
      return null;
    }

    return (
      <Message
        extraClasses="message-center message-border-radius green-theme"
        html
        message={DEPOSIT_MESSAGE.replace(
          '%price',
          formatCurrency(deal.currency, deal?.depositPrice),
        )}
        showIcon={false}
      />
    );
  };

  const selectBox = (data, value, action, htmlId, products) => {
    const selectedItem = value ? data.items.find((x) => x.id === value) : null;

    return (
      <>
        <Dropdown>
          <Dropdown.Toggle
            className="dropdown-outline"
            id={htmlId}
            style={{ whiteSpace: 'collapse' }}
          >
            {selectedItem
              ? getDropdownDisplayItem(selectedItem)
              : `${PLEASE_CHOOSE} ${data.label}`}
          </Dropdown.Toggle>

          <Dropdown.Menu className="full-width-list" id="menu-list">
            <Dropdown.Item
              className="full-width-list"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                action(0);
              }}
            >
              {PLEASE_CHOOSE} {data.label}
            </Dropdown.Item>

            {data.items.map((item) => {
              if ((isLightPage() && !item.disabled) || !isLightPage())
                return (
                  <Dropdown.Item
                    className="dropdown-item"
                    disabled={item.disabled}
                    href={
                      isSingleDropDown
                        ? getPdtUrlWithOneDropDown(
                            products,
                            item?.id,
                          )?.toString()
                        : htmlId == 'columnId'
                        ? getPdtUrlWithTwoDropDown(
                            products,
                            item?.id,
                          )?.toString()
                        : '/'
                    }
                    key={item.id}
                    onClick={(e) => {
                      e.preventDefault();
                      action(item.id);
                    }}
                    value={item.id}
                  >
                    {/**
                     * Not showing new vip price for sold out deals
                     */}
                    {getDropdownDisplayItem(item)}
                    {item.vipExclusive && (
                      <span className="green-text text-wrap">
                        {CUE_VIP_EXCLUSIVE}
                      </span>
                    )}
                    {item.isBestSeller && <div>{BESTSELLER_EXPLAIN}</div>}
                  </Dropdown.Item>
                );

              return null;
            })}
          </Dropdown.Menu>
        </Dropdown>

        <style jsx>
          {`
            :global(.dropdown-outline) {
              width: 100%;
              background-color: transparent;
              color: ${theme.commoncolors.greycharcoal};
              border: 1px solid ${theme.commoncolors.inputiconcolor};
              font-size: large;
              min-width: 50px;
              min-height: 32px;
              border-radius: 5px;
              padding: 0px 10px 0px 8px;
              appearance: none;
              line-height: 1.2em;
              margin-bottom: 10px;
              text-align: left;
            }
            :global(.dropdown-outline:hover) {
              background-color: transparent;
              color: ${theme.commoncolors.greycharcoal};
              border: 1px solid ${theme.commoncolors.inputiconcolor};
            }
            :global(.dropdown-outline.dropdown-toggle) {
              background-color: transparent !important;
              color: ${theme.commoncolors.greycharcoal} !important;
              border: 1px solid ${theme.commoncolors.inputiconcolor} !important;
            }
            :global(.dropdown-outline::after) {
              float: right;
              margin-top: 6px;
            }
            :global(.full-width-list) {
              width: 100%;
              font-size: 13px;
            }
            :global(.dropdown-item) {
              display: flex;
              align-items: center;
              gap: 1rem;
              font-size: large;
            }
            :global(.green-text) {
              color: ${theme.commoncolors.assure};
            }
            .text-wrap {
              white-space: normal;
            }

            @media (max-width: ${theme.breakpoints.smUp}) {
              .outline.green-text {
                display: none;
              }
            }
          `}
        </style>
      </>
    );
  };
  const ChooseYourOptionsInputs = () => {
    return (
      <div className="choose-your-options__inputs">
        {/* ROW SELECTION */}
        {selectBox(row, rowSelection, onRowChange, 'rowId', deal?.products)}

        {/* COLUMN SELECTION (HIDDEN IF ONLY 1 OPTION) */}
        {column.items.length > 1 &&
          selectBox(
            column,
            columnSelection,
            onSecondRowChange,
            'columnId',
            deal?.products,
          )}
        {(bestsellerProduct?.rowId === rowSelection ||
          bestsellerProduct?.columnId === columnSelection) && (
          <div className="deal-product-selector__footnote">
            {BESTSELLER_EXPLAIN}
          </div>
        )}
        <div
          className={`deal-product-selector__empty-message ${
            showEmptyMessage ? 'visible ' : 'hidden'
          }`}
        >
          {PLEASE_CHOOSE_ONE_OPTION}
        </div>
        {deal?.products[selectedOption]?.soldOut && (
          <div className={`deal-product-selector__empty-message visible`}>
            {PLEASE_CHOOSE_ANOTHER_OPTION}
          </div>
        )}
      </div>
    );
  };

  const PayAmount = () => {
    if (!isDepositDeal(deal)) return false;

    return columnSelection ? (
      <div className="cyo-deposit">
        <RadioButtonWithLabel
          checked={payDeposit}
          className={classNames('radio-button--boxed radio-button--switch', {
            'radio-button--green': payDeposit,
          })}
          label={
            <>
              <p className="label-text">{DEPOSIT_PAY_DEPOSIT}</p>
              <p className="label-price">
                {formatCurrency(deal.currency, deal?.depositPrice)}
              </p>
            </>
          }
          onChange={() => setPayDeposit(true)}
        />
        <RadioButtonWithLabel
          checked={!payDeposit}
          className={classNames('radio-button--boxed radio-button--switch', {
            'radio-button--green': !payDeposit,
          })}
          label={
            <>
              <p className="label-text">{DEPOSIT_PAY_FULL}</p>
              <p className="label-price">
                {formatCurrency(deal.currency, deal?.price)}
              </p>
            </>
          }
          onChange={() => setPayDeposit(false)}
        />
      </div>
    ) : null;
  };

  let friendlyName;
  const selectedProduct = deal?.products?.filter(
    (product) => product.id === productionId,
  );
  if (selectedProduct?.length > 0) {
    friendlyName = selectedProduct[0].friendlyName;
  }
  if (rowSelection > 0) {
    if (
      updateProductPageDetails(column, isChooseYourProductDeal, columnSelection)
    ) {
      const matchingObject = deal?.products?.filter((product) =>
        isChooseYourProductDeal
          ? product.id === rowSelection
          : product.rowId === rowSelection,
      );
      friendlyName = matchingObject[0]?.friendlyName;
    }

    if (columnSelection) {
      const matchingColumn = deal?.products?.filter(
        (product) =>
          product.columnId === columnSelection &&
          product.rowId === rowSelection,
      );
      friendlyName = matchingColumn[0]?.friendlyName;
    }
  }

  return (
    <>
      {!isLayoutTravel && (
        <>
          {isMobile && (
            <DealPriceSplat
              className="main-deal--mobile--product-page"
              columnSelection={columnSelection}
              deal={deal}
              forcePrice
              isHideIfNoDiscount={false}
              isProductPage={isProductPage}
              rowSelection={rowSelection}
            />
          )}
          <div className="cyo-friendly-name">
            {friendlyName || selectedProduct?.[0]?.friendlyName}
          </div>
          <DepositMessage />
          {ChooseYourOptionsInputs()}
          <PayAmount />
        </>
      )}

      <style jsx>{`
        .cyo-header {
          background-color: ${theme.colors.primary};
          min-height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          text-align: center;
          font-size: 20px;
          color: ${theme.colors.textonprimary};
          text-transform: capitalize;
        }
        .cyo-friendly-name {
          min-height: 70px;
          margin: 8px;
          padding-top: 5px;
          font-weight: bold;
          font-size: 18px;
          margin-top: 8px;
          width: 75%;
        }
        .cyo-body {
          display: flex;
          flex-direction: column;
          border: 4px solid ${theme.colors.primary};
          border-top: none;
          padding: 20px;
        }
        .cyo-buttons {
          padding-top: 10px;
        }
        .cyo-block {
          margin-bottom: 20px;
        }
        :global(.cyo-deposit) {
          display: flex;
          padding: 5px 0px 10px 0px;
        }
        :global(.vip-new-variant) {
          background-color: #ffdff2;
          color: #eb008c;
          border-radius: 12px;
          padding: 2px 6px;
          line-height: 1;
          vertical-align: middle;
          display: inline-block;
          margin-right: 6px;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          :global(.cyo-deposit) {
            padding-bottom: 10px;
          }
        }
        :global(.cyo-deposit label) {
          flex-grow: 1;
        }
        :global(.cyo-deposit label .label-text),
        :global(.cyo-deposit label .label-price) {
          margin: 0px;
        }
        :global(.cyo-deposit label:first-child) {
          margin-right: 10px;
        }

        :global(.choose-your-options__cue) {
          overflow: hidden;
        }

        @media (max-width: ${theme.breakpoints.smDown}) {
          :global(.choose-your-options__cue) {
            padding-top: 10px;
          }
        }
        :global(.choose-your-options__discount) {
          float: right;
          padding: 0 0 10px 10px;
        }
        .choose-your-options__image-container {
          padding: 20px 0px 20px 0px;
        }
        .choose-your-options__image {
          width: 100%;
        }
        .choose-your-options__inputs {
          padding: 0px 0px 12px 0px;
        }

        @media (max-width: ${theme.breakpoints.smDown}) {
          :global(.choose-your-options__inputs) {
            margin-top: ${rowSelection === 0 && columnSelection === 0
              ? '20px'
              : '25px'};
          }
        }
        @media (min-width: ${theme.breakpoints.smDown}) and (max-width: ${theme
            .breakpoints.mdUp}) {
          :global(.choose-your-options__inputs) {
            margin-top: ${rowSelection === 0 && columnSelection === 0
              ? '40px'
              : '20px'};
          }
        }

        :global(.deal-product-selector__empty-message) {
          margin: 0 auto 20px;
          padding: 6px 12px;
          color: ${theme.commoncolors.alert};
          border: 4px solid ${theme.commoncolors.alert};
          border-radius: 4px;
          text-align: center;
        }
        :global(.deal-product-selector__empty-message.hidden) {
          display: none;
        }
        :global(.deal-product-selector__footnote) {
          margin: -5px 0 15px 0;
        }
        :global(.choose-your-options .modal-body) {
          padding: 0 20px 20px 20px;
        }
        :global(.choose-your-options__discount .deal-main-deal__discount) {
          background: ${theme.colors.primary};
        }
        :global(.choose-your-options .modal-content) {
          border: 1px solid ${theme.colors.primary};
        }

        :global(.size-larger) {
          position: ${layoutOptions.travel ? 'static' : 'sticky'};
          bottom: 0px;
          z-index: 1001;
        }
      `}</style>
    </>
  );
};

ChooseYourOptionsDropdown.propTypes = {
  columnSelection: PropTypes.number,
  deal: PropTypes.object,
  isMobile: PropTypes.bool,
  isModernVipVariant: PropTypes.bool,
  layout: PropTypes.string,
  rowSelection: PropTypes.number,
  setColumnSelection: PropTypes.func,
  setIsOptionSelected: PropTypes.func,
  setProductStatus: PropTypes.func,
  setRowSelection: PropTypes.func,
  setSelectedOption: PropTypes.func,
  setShowEmptyMessage: PropTypes.func,
  showEmptyMessage: PropTypes.bool,
};

export default ChooseYourOptionsDropdown;
